import 'babel-polyfill'

import Vue from 'vue'
import Vuex from 'vuex'
import VueLoading from 'vuex-loading'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, min, max, numeric, regex } from 'vee-validate/dist/rules'
import VueClipboards from 'vue-clipboards'
import BootstrapVue from 'bootstrap-vue'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import i18n from './plugins/locale'
// import firebase from 'firebase'

import app from '@/App'
import store from '@/store'
import router from '@/router'
import filters from '@/filters'

// for modal
Vue.use(BootstrapVue)

// production tips
Vue.config.productionTip = false

// vuex
Vue.use(Vuex)

// use filters
Vue.use(filters)

// vue loading
Vue.use(VueLoading)

// use validation
extend('required', required)
extend('min', min)
extend('max', max)
extend('numeric', numeric)
extend('regex', regex)
extend('minmax', {
  validate(value, { min, max }) {
    return value.length >= min && value.length <= max
  },
  params: ['min', 'max'],
  message: `The {_field_} must be between {min} and {max}.`
})
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

// use copy
Vue.use(VueClipboards)

// Vue Form Wizard
Vue.use(VueFormWizard)

// Firebase
// const config = {
//   apiKey: 'AIzaSyD0_spH-gSmhvQq61GEZwzME-s8yJisGHM',
//   authDomain: 'astech-hybrid-europe.firebaseapp.com',
//   databaseURL: 'https://astech-hybrid-europe.firebaseio.com',
//   projectId: 'astech-hybrid-europe',
//   storageBucket: 'astech-hybrid-europe.appspot.com',
//   messagingSenderId: '614409815726'
// }
// firebase.initializeApp(config)

/* eslint-disable no-new */
window.vueApp = new Vue({
  el: '#app',
  template: '<app/>',
  store,
  router,
  i18n,
  components: { app },
  vueLoading: new VueLoading({ useVuex: true })
})



// WEBPACK FOOTER //
// ./src/main.js